/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

const InputField = ({
  field: { name, value, onChange, required }, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <div
      className={`mt-2 relative ${errors[name] && touched[name] && 'errors'}`}
    >
      {props.label && (
        <label htmlFor={name} className="form-label flex mb-1">
          {props.label}
        </label>
      )}
      {props.type === 'textarea' ? (
        <textarea
          id={name}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          rows={props.rows}
          required={required}
          className="ffh-form__input block w-full px-3 py-2 border border-neutral-300 rounded-lg shadow-sm placeholder-neutral-300 focus:outline-none focus:ring-primary-600 focus:border-primary-600 text-base"
        ></textarea>
      ) : (
        <input
          id={name}
          placeholder={props.placeholder}
          value={value}
          name={name}
          type={props.type}
          onChange={onChange}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          required={required}
          data-cy={name}
          className="ffh-form__input block w-full px-3 py-2 border border-neutral-300 rounded-lg shadow-sm placeholder-neutral-600 focus:outline-none focus:ring-primary-600 focus:border-primary-600 text-base sm:text-base"
        />
      )}
    </div>
  );
};

export default InputField;
